export const radioComponentOverrides = {
    MuiRadio: {
        styleOverrides: {
            root: ({ theme }) => ({
                height: '1.875rem',
                width: '1.875rem',
                color: theme.tokens.FuelColorBorderDark,
                marginLeft: theme.spacing(1),
                boxSizing: 'border-box',
                '&:hover, &.Mui-checked': {
                    color: theme.tokens.FuelColorBrandPrimary,
                    backgroundColor: 'unset'
                },
                '&.Mui-focusVisible .MuiSvgIcon-root': {
                    borderRadius: '50%',
                    boxShadow: `0 0 0 0.125rem ${theme.tokens.FuelColorFocused}`
                },
                '&.Mui-disabled': {
                    opacity: 0.4
                },
                '&.Mui-disabled, &[aria-readonly="true"]': {
                    cursor: 'default',
                    pointerEvents: 'none'
                }
            })
        }
    }
};
